/* eslint-disable */
import eyeContourSerumVideoSmall from '@/assets/videos/serum-making/eye-contour-serum-small.mp4';
import eyeContourSerumVideoMedium from '@/assets/videos/serum-making/eye-contour-serum-medium.mp4';
import eyeContourSerumVideoLarge from '@/assets/videos/serum-making/eye-contour-serum-large.mp4';

import serumPackVideoSmall from '@/assets/videos/serum-making/serum-pack-small.mp4';
import serumPackVideoMedium from '@/assets/videos/serum-making/serum-pack-medium.mp4';
import serumPackVideoLarge from '@/assets/videos/serum-making/serum-pack-large.mp4';

import cubeVideoLarge from '@/assets/videos/ingredients/ingredients-cube-large.mp4';
import cubeVideoMedium from '@/assets/videos/ingredients/ingredients-cube-medium.mp4';
import cubeVideoSmall from '@/assets/videos/ingredients/ingredients-cube-small.mp4';

import aloeVideoLarge from '@/assets/videos/ingredients/aloe-large.mp4';
import aloeVideoMedium from '@/assets/videos/ingredients/aloe-medium.mp4';
import aloeVideoSmall from '@/assets/videos/ingredients/aloe-small.mp4';

import arbutinVideoLarge from '@/assets/videos/ingredients/arbutin-large.mp4';
import arbutinVideoMedium from '@/assets/videos/ingredients/arbutin-medium.mp4';
import arbutinVideoSmall from '@/assets/videos/ingredients/arbutin-small.mp4';

import ascorbicVideoLarge from '@/assets/videos/ingredients/ascorbic-large.mp4';
import ascorbicVideoMedium from '@/assets/videos/ingredients/ascorbic-medium.mp4';
import ascorbicVideoSmall from '@/assets/videos/ingredients/ascorbic-small.mp4';

import azelaicVideoLarge from '@/assets/videos/ingredients/azelaic-large.mp4';
import azelaicVideoMedium from '@/assets/videos/ingredients/azelaic-medium.mp4';
import azelaicVideoSmall from '@/assets/videos/ingredients/azelaic-small.mp4';

import dmaeVideoLarge from '@/assets/videos/ingredients/dmae-large.mp4';
import dmaeVideoMedium from '@/assets/videos/ingredients/dmae-medium.mp4';
import dmaeVideoSmall from '@/assets/videos/ingredients/dmae-small.mp4';

import dpanthenolVideoLarge from '@/assets/videos/ingredients/dpanthenol-large.mp4';
import dpanthenolVideoMedium from '@/assets/videos/ingredients/dpanthenol-medium.mp4';
import dpanthenolVideoSmall from '@/assets/videos/ingredients/dpanthenol-small.mp4';

import ferulicVideoLarge from '@/assets/videos/ingredients/ferulic-large.mp4';
import ferulicVideoMedium from '@/assets/videos/ingredients/ferulic-medium.mp4';
import ferulicVideoSmall from '@/assets/videos/ingredients/ferulic-small.mp4';

import glycolicVideoLarge from '@/assets/videos/ingredients/glycolic-large.mp4';
import glycolicVideoMedium from '@/assets/videos/ingredients/glycolic-medium.mp4';
import glycolicVideoSmall from '@/assets/videos/ingredients/glycolic-small.mp4';

import isoVideoLarge from '@/assets/videos/ingredients/iso-large.mp4';
import isoVideoMedium from '@/assets/videos/ingredients/iso-medium.mp4';
import isoVideoSmall from '@/assets/videos/ingredients/iso-small.mp4';

import kojicVideoLarge from '@/assets/videos/ingredients/kojic-large.mp4';
import kojicVideoMedium from '@/assets/videos/ingredients/kojic-medium.mp4';
import kojicVideoSmall from '@/assets/videos/ingredients/kojic-small.mp4';

import lactoVideoLarge from '@/assets/videos/ingredients/lacto-large.mp4';
import lactoVideoMedium from '@/assets/videos/ingredients/lacto-medium.mp4';
import lactoVideoSmall from '@/assets/videos/ingredients/lacto-small.mp4';

import madecaVideoLarge from '@/assets/videos/ingredients/madeca-large.mp4';
import madecaVideoMedium from '@/assets/videos/ingredients/madeca-medium.mp4';
import madecaVideoSmall from '@/assets/videos/ingredients/madeca-small.mp4';

import niacinamideVideoLarge from '@/assets/videos/ingredients/niacinamide-large.mp4';
import niacinamideVideoMedium from '@/assets/videos/ingredients/niacinamide-medium.mp4';
import niacinamideVideoSmall from '@/assets/videos/ingredients/niacinamide-small.mp4';

import phyticVideoLarge from '@/assets/videos/ingredients/phytic-large.mp4';
import phyticVideoMedium from '@/assets/videos/ingredients/phytic-medium.mp4';
import phyticVideoSmall from '@/assets/videos/ingredients/phytic-small.mp4';

import retinolVideoLarge from '@/assets/videos/ingredients/retinol-large.mp4';
import retinolVideoMedium from '@/assets/videos/ingredients/retinol-medium.mp4';
import retinolVideoSmall from '@/assets/videos/ingredients/retinol-small.mp4';

import rutinVideoLarge from '@/assets/videos/ingredients/rutin-large.mp4';
import rutinVideoMedium from '@/assets/videos/ingredients/rutin-medium.mp4';
import rutinVideoSmall from '@/assets/videos/ingredients/rutin-small.mp4';

import salicylicVideoLarge from '@/assets/videos/ingredients/salicylic-large.mp4';
import salicylicVideoMedium from '@/assets/videos/ingredients/salicylic-medium.mp4';
import salicylicVideoSmall from '@/assets/videos/ingredients/salicylic-small.mp4';

import sodVideoLarge from '@/assets/videos/ingredients/sod-large.mp4';
import sodVideoMedium from '@/assets/videos/ingredients/sod-medium.mp4';
import sodVideoSmall from '@/assets/videos/ingredients/sod-small.mp4';

import zincVideoLarge from '@/assets/videos/ingredients/zinc-large.mp4';
import zincVideoMedium from '@/assets/videos/ingredients/zinc-medium.mp4';
import zincVideoSmall from '@/assets/videos/ingredients/zinc-small.mp4';

import { SCREEN_SIZE, MEDIA_TYPE } from '@/constants/common';

const createVideoSource = (src, mediaType = MEDIA_TYPE.VIDEO_MP4) => ({ src, type: mediaType });

const VIDEO_RESOURCE_NAME = {
  EYE_CONTOUR_SERUM: 'eyeContourSerum',
  SERUM_PACK: 'serumPack',
  DAY_SERUM_POWDER: 'daySerumPowder',
  DAY_AND_NIGHT_SERUM_POWDER: 'dayAndNightSerumPowder',
  NIGHT_SERUM_POWDER: 'nightSerumPowder',
  CUBE: 'cube',
  ALOE: 'aloe',
  ARBUTIN: 'arbutin',
  ASCORBIC: 'ascorbic',
  AZELAIC: 'azelaic',
  DMAE: 'dmae',
  DPANTHENOL: 'dpanthenol',
  FERULIC: 'ferulic',
  GLYCOLIC: 'glycolic',
  ISO: 'iso',
  KOJIC: 'kojic',
  LACTO: 'lacto',
  MADECA: 'madeca',
  NIACINAMIDE: 'niacinamide',
  PHYTIC: 'phytic',
  RETINOL: 'retinol',
  RUTIN: 'rutintx',
  SALICYLIC: 'salicylic',
  SOD: 'sod',
  ZINC: 'zinc',
  TRANEXAMIC:'tranexamic',
  RETINAL:'retinal'
};

const VIDEO_RESOURCE = {
  [VIDEO_RESOURCE_NAME.EYE_CONTOUR_SERUM]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(eyeContourSerumVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(eyeContourSerumVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(eyeContourSerumVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.SERUM_PACK]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(serumPackVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(serumPackVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(serumPackVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.CUBE]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(cubeVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(cubeVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(cubeVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.ALOE]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(aloeVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(aloeVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(aloeVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.ARBUTIN]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(arbutinVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(arbutinVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(arbutinVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.ASCORBIC]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(ascorbicVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(ascorbicVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(ascorbicVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.AZELAIC]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(azelaicVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(azelaicVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(azelaicVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.DMAE]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(dmaeVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(dmaeVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(dmaeVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.DPANTHENOL]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(dpanthenolVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(dpanthenolVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(dpanthenolVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.FERULIC]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(ferulicVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(ferulicVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(ferulicVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.GLYCOLIC]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(glycolicVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(glycolicVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(glycolicVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.ISO]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(isoVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(isoVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(isoVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.KOJIC]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(kojicVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(kojicVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(kojicVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.LACTO]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(lactoVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(lactoVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(lactoVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.MADECA]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(madecaVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(madecaVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(madecaVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.NIACINAMIDE]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(niacinamideVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(niacinamideVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(niacinamideVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.PHYTIC]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(phyticVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(phyticVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(phyticVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.RETINOL]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(retinolVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(retinolVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(retinolVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.RUTIN]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(rutinVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(rutinVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(rutinVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.SALICYLIC]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(salicylicVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(salicylicVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(salicylicVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.SOD]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(sodVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(sodVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(sodVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.ZINC]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(zincVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(zincVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(zincVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.RETINAL]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(retinolVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(retinolVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(retinolVideoLarge)
  },
  [VIDEO_RESOURCE_NAME.TRANEXAMIC]: {
    [SCREEN_SIZE.SMALL]: createVideoSource(arbutinVideoSmall),
    [SCREEN_SIZE.MEDIUM]: createVideoSource(arbutinVideoMedium),
    [SCREEN_SIZE.LARGE]: createVideoSource(arbutinVideoLarge)
  }
};

const RESPONSIVE_VIDEO_SIZE_MAP = {
  [SCREEN_SIZE.EXTRA_SMALL]: SCREEN_SIZE.SMALL,
  [SCREEN_SIZE.SMALL]: SCREEN_SIZE.MEDIUM,
  [SCREEN_SIZE.MEDIUM]: SCREEN_SIZE.LARGE,
  [SCREEN_SIZE.LARGE]: SCREEN_SIZE.LARGE,
  [SCREEN_SIZE.EXTRA_LARGE]: SCREEN_SIZE.LARGE
};

export { VIDEO_RESOURCE, VIDEO_RESOURCE_NAME, RESPONSIVE_VIDEO_SIZE_MAP };
